// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RedEnvelopeOutlinedSvg from "@fishx/icons-svg/es/asn/RedEnvelopeOutlined";
import FishxIcon from '../components/FishxIcon';

var RedEnvelopeOutlined = function RedEnvelopeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RedEnvelopeOutlinedSvg
  }));
};

RedEnvelopeOutlined.displayName = 'RedEnvelopeOutlined';
export default React.forwardRef(RedEnvelopeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RedEnvelopeOutlined.js
// module id = 3979
// module chunks = 0